import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { userSelector } from '../../../store/selectors/baseSelectors'
import { screenSizeSelector } from '../../../store/selectors/boardSelectors'
import { currentBoardSelector, currentBlockSelector } from '../../../store/selectors/selectors'

const ViewControlsContainer = compose(
  connect(state => {
    const user = userSelector(state)
    return {
      anon: !user || user.isEmpty || user.isAnonymous,
      board: currentBoardSelector(state),
      block: currentBlockSelector(state),
      screenSize: screenSizeSelector(state)
    }
  }),
  withTranslation()
)

export default ViewControlsContainer
